module.exports = __webpack_public_path__ + "static/img/1a.f1f6415.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/why/1a.png
// module id = rnWd
// module chunks = 1